module.exports = __webpack_public_path__ + "static/2_1_chicken-crossing-2_CS-9616b5ceaf3acac26254ce6e06cf8575.svg";